import React from 'react'
import styled from 'react-emotion'

const Img = styled('img')`
  width: 100%;
`

export const StickerAnimation = ({ apng, ...props }) => <Img src={apng} />
